import { useWalkUpload } from "@/contexts/WalkUploadContext";
import { Progress } from "@/components/ui/progress";
import { Upload } from "lucide-react";

export function WalkUploadIndicator() {
  const { uploads } = useWalkUpload();

  if (uploads.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 w-72 rounded-lg border bg-card p-3 shadow-lg space-y-2">
      <div className="flex items-center gap-2 text-sm font-medium">
        <Upload className="h-4 w-4" />
        Lädt {uploads.length} Datei{uploads.length > 1 ? "en" : ""} hoch…
      </div>
      <div className="space-y-1.5">
        {uploads.map((u) => (
          <div key={u.id} className="space-y-0.5">
            <div className="flex items-center justify-between text-xs text-muted-foreground">
              <span className="truncate">{u.dogName}{u.isVideo ? " (Video)" : ""}</span>
              <span>{u.status === "error" ? "Fehler" : `${u.pct}%`}</span>
            </div>
            <Progress value={u.status === "error" ? 0 : u.pct} className="h-1.5" />
          </div>
        ))}
      </div>
    </div>
  );
}
